import { useCallback, useState, type Dispatch, type SetStateAction } from "react";

import { emptyLibraryFilters, type LibraryTagFilters } from "./libraryFilters";
import type { LibraryFilter } from "./useLibrary";

// The Create-hub's own library search (tab + tag filters), lifted ABOVE
// CreateHubLibraryWeb / CreateHubLibrary (MX-8b, following useHomeCardDrafts'
// same lift for Home): the hub's LibraryBrowser mount would otherwise lose
// this to a wide/narrow resize (HomeView.tsx's sibling problem, MX-8). One
// hook, called by both useCreateHubWeb (web-rnw) and useCreateHubNav
// (mobile): they held two copies of the same pair of useState plus reset
// before this (review finding, 25/09).
export function useHubLibrarySearch(): {
  filter: LibraryFilter;
  setFilter: Dispatch<SetStateAction<LibraryFilter>>;
  tagFilters: LibraryTagFilters;
  setTagFilters: Dispatch<SetStateAction<LibraryTagFilters>>;
  /** Back to defaults. Callers reset on every path that closes the hub, not
   *  only its own close button; see each caller's own header note. */
  reset: () => void;
} {
  const [filter, setFilter] = useState<LibraryFilter>("programs");
  const [tagFilters, setTagFilters] =
    useState<LibraryTagFilters>(emptyLibraryFilters);

  const reset = useCallback(() => {
    setFilter("programs");
    setTagFilters(emptyLibraryFilters);
  }, []);

  return { filter, setFilter, tagFilters, setTagFilters, reset };
}
